/**
 * currentNumberOfDays selectors
 */
interface State {
    currentNumberOfDays?: number;
}

const selectCurrentNumberOfDays = (state: State) => state.currentNumberOfDays;

export { selectCurrentNumberOfDays };
